import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import ReplayIcon from "@mui/icons-material/Replay";
import { Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import errorImage from "../../../assets/images/errorImage.png";
import { closeIframe } from "../../../utils/iframe";
import {
  ErrorButtonsContainer,
  ErrorContainer,
  ErrorImage,
  TextContainer,
} from "../../styled/Error";
import ErrorButton from "../errorButton/ErrorButton";

const Error = () => {
  const call = useSelector((state) => state.call.call);
  const error = useSelector((state) => state.error);

  return (
    <ErrorContainer>
      <TextContainer>
        <ErrorImage src={errorImage} alt="error" />
        <ErrorOutlineIcon
          sx={{ fontSize: 30, color: "primary.dark", mt: { xs: 1, md: 0 } }}
        />
        <Typography
          variant="overline"
          sx={{
            margin: 1,
            fontSize: { xs: 12, md: 16 },
            fontWeight: 600,
            color: "primary.dark",
          }}>
          {!error.code
            ? "Algo ha salido mal..."
            : `${error.code} - ${error.message}`}
        </Typography>
      </TextContainer>
      <ErrorButtonsContainer>
        <ErrorButton
          text="Reintentar"
          icon={<ReplayIcon />}
          action={() => window.location.reload()}
        />
        {call.data?.tipoParticipante === 0 && (
          <ErrorButton
            icon={<LogoutIcon />}
            action={closeIframe}
            color="error"
            usarIconoEnBlanco
            text="Volver"
          />
        )}
      </ErrorButtonsContainer>
    </ErrorContainer>
  );
};

export default Error;
